/**
 * ErrorListItemBadge  component
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { BEM } from "@adapptio/lib-components";

export interface IErrorListItemBadgeProps {
	className?: string;
	children?: React.ReactNode;
}

export const ErrorListItemBadge = React.memo<IErrorListItemBadgeProps>(({ className, ...props }) => {
	const baseClass = BEM("edt-error-list", "item-badge");

	if (className) {
		baseClass.add(className);
	}

	return <div className={baseClass.toClassName()} {...props} />;
});

ErrorListItemBadge.displayName = "ErrorListItemBadge";
